/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Toggle_Fast_ForwardInputs */



/**
* | output |
* | --- |
* | "Fast Forward through video (foot fedal recommended)" |
*
* @param {Shortcut_Keys_Desc_Toggle_Fast_ForwardInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_toggle_fast_forward = /** @type {((inputs?: Shortcut_Keys_Desc_Toggle_Fast_ForwardInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Toggle_Fast_ForwardInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Avance rapide dans la video (pedale recommandee)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schnellvorlauf im Video (Fußfesselung empfohlen)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avanzamento rapido nel video (si consiglia l'uso del piede)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перемотайте видео вперед (рекомендуется использовать педаль).")
	if (locale === "es") return /** @type {LocalizedString} */ ("Avance rápido a través del video (se recomienda el uso del pie)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频快进（建议使用脚踏快进）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオを早送りする（徒歩での視聴を推奨）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो को तेजी से आगे बढ़ाएं (फुट पैडल का इस्तेमाल करने की सलाह दी जाती है)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Avance rapidamente o vídeo (recomenda-se o uso do pé para avançar).")
	return /** @type {LocalizedString} */ ("Fast Forward through video (foot fedal recommended)")
});